"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KNOWN_CONSENT_VERSIONS = exports.CURRENT_CONSENT_VERSION = exports.CONSENT_VERSIONS = void 0;
const consent_v1_js_1 = __importDefault(require("./consent-v1.js"));
const consent_v2_js_1 = __importDefault(require("./consent-v2.js"));
const consent_v3_js_1 = __importDefault(require("./consent-v3.js"));
const consent_v4_js_1 = __importDefault(require("./consent-v4.js"));
exports.CONSENT_VERSIONS = {
    'consent-v1': consent_v1_js_1.default,
    'consent-v2': consent_v2_js_1.default,
    'consent-v3': consent_v3_js_1.default,
    'consent-v4': consent_v4_js_1.default,
};
exports.CURRENT_CONSENT_VERSION = 'consent-v4';
// Object.keys widens to string[]; the cast is safe because the object is an
// as-const literal — its keys are exactly ConsentVersion at runtime.
exports.KNOWN_CONSENT_VERSIONS = Object.keys(exports.CONSENT_VERSIONS);
